import Estructura from 'features/organigrama/components/Estructura'

const Organigrama = () => {
  return <Estructura />
}

export default Organigrama
